@let search =
  texts() | filterTexts: ERelationType.search : EEntityType.generic | language;
@let searchDisabled =
  texts()
    | filterTexts: ERelationType.searchDisabled : EEntityType.generic
    | language;
<div
  class="flex flex-col gap-4 rounded-lg border-1 p-6"
  [ngStyle]="{
    borderRadius: corporateDesign.borderRadius(),
    borderColor: corporateDesign.primaryBorderColor(),
    backgroundColor: corporateDesign.surface1(),
  }">
  <div class="flex flex-col md:flex-row">
    <div
      class="flex flex-col flex-wrap items-center justify-center pb-4 md:w-2/3 md:flex-row md:pr-4 md:pb-0">
      <aw-auto-complete
        class="md:w-5/12"
        [showResetIcon]="true"
        [label]="
          texts()
            | filterTexts: ERelationType.origin : EEntityType.relationSearch
            | language
        "
        [isLoading]="originsStore.isLoading()"
        [options]="origins()"
        (onSearch)="loadOrigins($event)"
        name="name"
        id="relation-search-origin"
        [formControl]="relationSearchForm.controls.origin"></aw-auto-complete>
      <aw-button
        class="px-2 py-2 md:w-2/12 md:py-0"
        type="button"
        [isDisabled]="
          !relationSearchForm.controls.origin.valid ||
          !relationSearchForm.controls.destination.valid
        "
        [disabledText]="
          texts()
            | filterTexts
              : ERelationType.switchDisabled
              : EEntityType.relationSearch
            | language
        "
        [style]="'primary-alt'"
        id="relation-search-switch-origin-and-destination"
        (click)="switchOriginAndDestination()"
        (keydown.enter)="switchOriginAndDestination()">
        <span class="material-symbols-rounded h-6 text-lg">swap_horiz</span>
      </aw-button>
      <aw-auto-complete
        class="md:w-5/12"
        [showResetIcon]="true"
        [label]="
          texts()
            | filterTexts
              : ERelationType.destination
              : EEntityType.relationSearch
            | language
        "
        [isLoading]="destinationsStore.isLoading()"
        [options]="destinations()"
        (onSearch)="loadDestinations($event)"
        name="name"
        id="relation-search-destination"
        [formControl]="
          relationSearchForm.controls.destination
        "></aw-auto-complete>
    </div>
    <div class="flex flex-col items-center md:w-1/3 md:flex-row">
      <aw-drop-down
        class="w-full"
        [showResetIcon]="true"
        [label]="
          texts()
            | filterTexts: ERelationType.via : EEntityType.relationSearch
            | language
        "
        [isLoading]="viasStore.isLoading()"
        [options]="vias()"
        (onSearch)="loadVias($event)"
        name="via"
        id="relation-search-via"
        [formControl]="relationSearchForm.controls.via"></aw-drop-down>
      <aw-button
        class="hidden w-full pt-4 md:block md:w-auto md:pt-0 md:pl-4"
        [disabledText]="searchDisabled"
        [isDisabled]="!relationSearchForm.valid"
        (click)="searchForTickets()"
        (keydown.enter)="searchForTickets()"
        type="submit"
        id="relation-search-send-desktop"
        >{{ search }}</aw-button
      >
    </div>
  </div>
  <aw-relation-date-input
    [headline]="
      texts()
        | filterTexts: ERelationType.editJourney : EEntityType.generic
        | language
    "
    [label]="
      texts()
        | filterTexts: ERelationType.startDate : EEntityType.relationSearch
        | language
    "
    [showTimePicker]="
      configuration.getEnumConfiguration(
        CONFIGURATION_SETTING_KEYS.RelationSearchAccuracy,
        ERelationSearchAccuracy
      ) === ERelationSearchAccuracy.ByMinute
    "
    [min]="today"
    id="relation-search-start-date"
    [departureControl]="
      relationSearchForm.controls.startDate
    "></aw-relation-date-input>
  <aw-button
    class="block w-full md:hidden"
    [disabledText]="searchDisabled"
    [isDisabled]="!relationSearchForm.valid"
    (click)="searchForTickets()"
    (keydown.enter)="searchForTickets()"
    type="submit"
    id="relation-search-send-mobile"
    >{{ search }}</aw-button
  >
</div>
